import {createUseStyles} from 'react-jss'
import {PayArticleModel} from "../../redux/types"
import ListItemCard from "../ListItemCard"
import {useTranslation} from 'react-i18next'
import { formatMoney } from '../../util/money'
import Badge from '../Badge'
import { Colors } from '../../constants/colors'

interface Props {
  payArticles: PayArticleModel[]
}

const PayArticleList = ({payArticles}: Props) => {
  const styles = useStyles()
  const {t} = useTranslation(['common']);

  const renderApprovalStatus = (approved: boolean) => {
    return (
      <Badge
        text={t(approved ? 'approved' : 'notApproved', {ns: 'common'})}
        backgroundColor={approved ? Colors.euro_800 : Colors.yen_600}
        textColor={approved ? Colors.gray4 : Colors.gray0}
      />
    )
  }

  const renderHeader = () => {
    return (
      <ListItemCard className={styles.listItemContainer}>
        <div className={styles.smallCell}>
          <strong>{t('code', {ns: 'common'})}</strong>
        </div>
        <div className={styles.defaultCell}>
          <strong>{t('name', {ns: 'common'})}</strong>
        </div>
        <div className={styles.defaultCell}>
          <strong>{t('value', {ns: 'common'})}</strong>
        </div>
        <div className={styles.smallCell}>
          <strong>{t('quantity', {ns: 'common'})}</strong>
        </div>
        <div className={styles.defaultCell}>
          <strong>{t('payday', {ns: 'common'})}</strong>
        </div>
        <div className={styles.defaultCell}>
          <strong>{t('approvalStatus', {ns: 'common'})}</strong>
        </div>
      </ListItemCard>
    )
  }

  const renderListItems = () => {
    return payArticles?.map((article, index) => {
      return (
        <ListItemCard key={`pay${index}`} className={styles.listItemContainer} index={index}>
          <div className={styles.smallCell}>
            {article.code}
          </div>
          <div className={styles.defaultCell}>
            {article.displayName}
          </div>
          <div className={styles.defaultCell}>
            {formatMoney(article.grossValue)}
          </div>
          <div className={styles.smallCell}>
            {article.quantity}
          </div>
          <div className={styles.defaultCell}>
            {article.payday?.paymentDate}
          </div>
          <div className={styles.defaultCell}>
            {renderApprovalStatus(article.approved)}
          </div>
        </ListItemCard>
      )
    })
  }

  return (
    <div className={styles.container}>
    {renderHeader()}
    {renderListItems()}
    </div>
  )
}

export default PayArticleList

const useStyles = createUseStyles({
  container: {
    width: '100%'
  },
  listItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'space-between'
  },
  smallCell: {
    flexShrink: 0,
    width: 60
  },
  defaultCell: {
    flexShrink: 0,
    width: 100
  }
})
